import { render, staticRenderFns } from "./CalculationSettings.vue?vue&type=template&id=aedd9732&scoped=true&"
import script from "./CalculationSettings.vue?vue&type=script&lang=js&"
export * from "./CalculationSettings.vue?vue&type=script&lang=js&"
import style0 from "./CalculationSettings.vue?vue&type=style&index=0&id=aedd9732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedd9732",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/CalculationSettings.vue
// module id = null
// module chunks = 